/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-assigned-tasks .overdue{background:#f93115!important;padding:4px!important}app-assigned-tasks .warning{background:#ffe668!important;padding:4px!important}app-assigned-tasks .ontime{background:#0c0!important;padding:4px!important}app-assigned-tasks .processing{background:#ffa100!important;padding:4px!important}app-assigned-tasks .paused{background:#a4d2e6!important;padding:4px!important}app-assigned-tasks .card-header{font-size:1.5em;font-weight:700;margin:13px 0 0 15px;cursor:pointer;display:inline-block}"];
export { styles as styles };
